import { createSlice } from '@reduxjs/toolkit';
import { get } from 'api/fetch';

// ================== Reducers ================== //

const slice = createSlice({
  name: 'nomad_insurance/HospitalSearch',
  initialState: {
    isLoading: true,
    insuranceCard: null,
    error: null
  },
  reducers: {
    // fetchInsuranceCard
    fetchInsuranceCardRequest: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    fetchInsuranceCardSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.error = null;
      state.insuranceCard = payload.length === 0 ? null : payload;
    },
    fetchInsuranceCardFailure: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
      state.insuranceCard = null;
    }
  }
});

export default slice.reducer;

// ================== Actions ================== //

const { actions } = slice;

export const fetchInsuranceCard = () => async (dispatch) => {
  dispatch(actions.fetchInsuranceCardRequest());

  try {
    const response = await get('/contracts/v1/id-cards', { isNIOrchestrator: true });
    dispatch(actions.fetchInsuranceCardSuccess(response));
  } catch (error) {
    dispatch(actions.fetchInsuranceCardFailure(error));
  }
};
